export default function Go_Multiple_Variable () {
  return (
    <div>
      <h1>Go_Multiple_Variable </h1>
      <p>Multiple Variables</p>
    </div>
  );
}